import React from 'react';
import { useSelector } from 'react-redux';
import { getTranslationsByCountry } from 'reducers/selectors/metadata';

const NO_METRICS_EVENT = "";
const EXTERNAL_URL_REGEXP = /https?:\/\/[^\s]+/;
const SPECIAL_URL_REGEXP = /\/fe\/sitesplus/;

const defaultLinkItem = {
  url: '',
  name: '',
  metricas_cat: '',
  metricas_act: '',
  metricas_lab: '',
}

const transformUrl = url => {
  if (SPECIAL_URL_REGEXP.test(url)) return url;
  return EXTERNAL_URL_REGEXP.test(url) ? url : `/${url}`
};

const MetricsAnchor = ({ linkItem = defaultLinkItem, children, ...aditionalProps }) => {
  const translations = useSelector(getTranslationsByCountry);

  const { url, name, ...dataAttributes } = { ...defaultLinkItem, ...linkItem };

  const getTranslation = key => translations?.[key] || '';
  const anchorLink = transformUrl(getTranslation(url));

  const handleClick = e => {
    const isActionInvalid = e.target === '_blank' || e.which === 2;

    const action = isActionInvalid ? () => {} : () => window.location = link;

    if (typeof window.fwk.common.metricas === 'undefined') return action();

    const event = e.getAttribute('data-metricas-event') || 'event_cms';
    const windowEvent = {
      tag: event,
      macrocat: dataAttributes.metricas_cat,
      macroact: dataAttributes.metricas_act,
      macrolab: dataAttributes.metricas_lab,
    };

    window?.fwk?.common?.metricas?.hitEvent(windowEvent, action);
  }

  return (
    <>
      <a
        href={anchorLink}
        data-metricas-event={NO_METRICS_EVENT}
        data-metricas-macrocat={dataAttributes.metricas_cat}
        data-metricas-macroact={dataAttributes.metricas_act}
        data-metricas-macrolab-orig={dataAttributes.metricas_lab}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        {...aditionalProps}
      >
        { getTranslation(name) }
        { children }
      </a>
    </>
  )
}

export default MetricsAnchor;